import React from "react";

interface IProps {
	value: boolean;
	switch: (onOff: boolean) => void;
	className: string;
	disabled?: boolean;
}
function Switch(props: React.PropsWithChildren<IProps>) {
	return (
		<div
			className={`${props.className} ${props.value ? "sw_on" : "sw_off"} ${props.disabled ? "disabled" : ""}`}
			onClick={() => props.disabled ? undefined : props.switch(!props.value)}
		>   
			<div>{props.children}</div>
		</div>
	);
}
export default (Switch);
